import { SettingService } from 'src/app/system-common/services/setting.service';
import { BaseComponent } from 'src/app/system-common/base/base.component';
import { AgentService } from './../services/agent.service';
import { Component, OnInit, SimpleChanges } from '@angular/core';
import { element } from 'protractor';

@Component({
  selector: 'sym-agent-signature',
  templateUrl: './agent-signature.component.html',
  styleUrls: ['./agent-signature.component.scss'],
})
export class AgentSignatureComponent extends BaseComponent<AgentService> {
  public isLoggedinAsRecrutiee;
  currServiceSignature: any;
  public triggerBtnID;
  public triggerBtnClick = false;
  public isSignatureButtonReq;

  constructor(agentService: AgentService, public settingService: SettingService) {
    super(agentService);
  }

  ngOnInit() {
    if (
      this.settingService.getSessionStorageValue('userType') != undefined &&
      this.settingService.getSessionStorageValue('userType') !== null
    ) {
      this.isLoggedinAsRecrutiee = this.settingService.getSessionStorageValue('userType');
      //this line is not required since it anyways navigates to login page
      //this.router.navigate(['login']);
    }
    if (
      this.service.responseIO.data.Entity.applicationStatusCd == 'SUBMITTED' ||
      this.service.responseIO.data.Entity.applicationStatusCd == 'COMPLETED' ||
      this.service.responseIO.data.Entity.applicationStatusCd == 'ONHOLD' ||
      this.service.responseIO.data.Entity.applicationStatusCd == 'REJECTED'
    ) {
      this.isSignatureButtonReq = false;
    } else {
      this.isSignatureButtonReq = true;
    }
  }

  public onSignatureDone(signatureObject?: any) {
    this.service.responseIO.data.ServiceSignatureList.forEach((element) => {
      if (signatureObject.guid == element.guid) {
        element.signature = signatureObject.signature;
        return this.service;
      } else {
        return (this.triggerBtnClick = true);
      }
    });
    this.triggerBtnClick = false;
  }
}
